<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>退款维护</el-breadcrumb-item>
      <el-breadcrumb-item>退款管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="0">
        <el-col :span="10">
          <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable
            style="width:300px " @clear="gettuikuanList" @change="gettuikuanList">
            <el-button slot="append" icon="el-icon-search" @click="gettuikuanList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="get_tuikuan_add" v-if="admin_flag===0" >退款申请</el-button>
        </el-col>
        <el-col :span="12"  style="text-align: right;" >
                    <el-button type="primary" @click="handleExport()">导出电子表格</el-button>
                </el-col>
      </el-row>
      <el-row :gutter="0" class="el_row_two">
        <el-col :span="24">
          <el-table :data="tuikuanList" style="width: 100%" border stripe id="report">
            <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
            <el-table-column prop="uid" label=" 序号" width="80"></el-table-column>
            <el-table-column prop="tuikuan_money" label="金额" width="120"></el-table-column>
            <el-table-column prop="tuikuan_sxf" label="手续费"></el-table-column>
            <el-table-column prop="add_time" label="时间"></el-table-column>
            <el-table-column   label="审核状态" >
              <template v-slot="scope">
                 <span style="color: brown;">{{ scope.row.tuikuan_sh_flag===1 ?'已处理':'未处理'}} </span> 
              </template>
            </el-table-column>
            <el-table-column  label="退款人信息"  >
              <template v-slot="scope">
                {{ scope.row.guest_name }}:{{ scope.row.guest_mob }}
              </template>
            </el-table-column>
            <el-table-column  label="所属门店信息"  >
              <template v-slot="scope2">
                {{ scope2.row.qiye_bianhao }}:{{ scope2.row.qiye_name }}:{{ scope2.row.qiye_mob }}
              </template>
            </el-table-column>
            <el-table-column prop="add_time" label="加入时间"></el-table-column>
            <el-table-column label="操作">
              <template v-slot="scope">
                 
                <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                  <el-button type="danger" icon="el-icon-delete" circle size="mini"
                    @click="deleteForm(scope.row.uid)"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="退款确认" placement="top" :enterable="false"
                  v-if="admin_flag===1">
                  <el-button type="success" icon="el-icon-orange" @click="tuikuanForm(scope.row.uid)" circle
                    size="mini"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
        <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
      </el-pagination>
      <!-- 退款窗口 -->

      <el-dialog title="退款" :visible.sync="huifangDialogVisible" width="50%" @close="huifangDoalogClosed">
 
      </el-dialog>
      <!-- 添加退款部分 -->
      <el-dialog title="添加退款" :visible.sync="addDialogVisible" width="50%" @close="addDoalogClosed">
        <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">
          <el-form-item label="退款编号" prop="tuikuan_bianhao">
            <el-input v-model="addForm.tuikuan_bianhao" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="选择小区" prop="xiaoqu_uid">
            <el-select v-model="addForm.xiaoqu_uid" placeholder="选择小区" @change="getGuestList(addForm.xiaoqu_uid)">
              <el-option v-for="item in xiaoquList" :key="item.uid" :label="item.xiaoqu_name"
                :value="item.xiaoqu_uid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择客户" prop="guest_uid">
            <el-select v-model="addForm.guest_uid" placeholder="选择客户"  >
              <el-option v-for="item in guestList" :key="item.uid" :label="item.guest_name +':' + item.guest_mob "
                :value="item.uid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="退款金额" prop="tuikuan_money">
            <el-input v-model="addForm.tuikuan_money"  width="10"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addtuikuan" :disabled="add_isDisable">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 修改退款信息 -->
      <el-dialog title="" :visible.sync="editDialogVisible" width="50%" @close="editDoalogClosed">
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import { checkMobileTest, checkSfzId } from './config/validator';
import exportExcel from './config/exportExcel'
export default {
  props: [
   'admin_flag'
  ],
  data() {
    return {
      tuikuanLy_options: [
        {
          value: 1,
          label: '退款介绍'
        },
        {
          value: 2,
          label: '退款'
        },
        {
          value: 3,
          label: '上门退款'
        }
      ],
      tuikuan_options: [
        {
          value: 1,
          label: '初级退款'
        },
        {
          value: 2,
          label: '中级退款'
        },
        {
          value: 3,
          label: '高级退款'
        }
      ],
      // 获取用户列表参数
      queryInfo: {
        C_type: 'get_list',
        C_table_name: 'tuikuan_list',
        query: '',
        pageNum: 1,
        pageSize: 10,
        qiye_uid: window.sessionStorage.getItem('qiye_uid')
      },
      huifang_isDisable: false,
      add_isDisable: false,
      tuikuanList: [],
      xiaoquList: [],
      guestList: [],
      //  recordCount: 0,
      total: 0,
      addDialogVisible: false,
      editDialogVisible: false,
      huifangDialogVisible: false,

      // 用于设置页面滑块值
      //  添加表单数据项
      huifangForm: {
        C_type: 'huifang_add',
        huifang_tuikuan_uid: 0,
        huifang_title: '',
        hufiang_memo: '',
        huifang_genjin: 1,
        huifang_yuangong_uid: 0,
        huifang_switch: true
      },
      addForm: {
        C_type: 'tuikuan_add',
        tuikuan_bianhao: '',
        xiaoqu_uid: '',
        guest_uid: '',
        tuikuan_money: 0
      },
      // 用于修改数据绑定
      editForm: {},
      // 表单规则项
      addFormRules: {
        tuikuan_money: [
          { required: true, message: '不能为空', trigger: 'blur' },
          { required: true, pattern: /^(([1-9][0-9]{0,3})|0|1000000)$/, message: '请输入0-10000数字', trigger: 'change' }
        ]
      } 
    };
  },
  created() {
    this.gettuikuanList();
   // this.getXiaoquList()
  },
  methods: {
    handleExport() {
      exportExcel('report', '导出.xlsx')
    },
    async getXiaoquList() {
      const { data: res } = await this.$http.get('get_api', {
        params: {
          C_type: 'xiaoqu_list_select' // 调用普通api get接口 
        }
      });
      this.xiaoquList = JSON.parse(res.data)[0].dataList
      console.log(this.xiaoquList)
    },
    async getGuestList(xiaoquUid) {
      const { data: res } = await this.$http.get('get_api', {
        params: {
          C_type: 'guest_list_select', // 调用普通api get接口 
          xiaoqu_uid: xiaoquUid
        }
      });
      this.guestList = JSON.parse(res.data)[0].dataList
      console.log(this.guestList)
    },
    get_switch_value(switchValue) {
      this.huifangForm.huifang_genjin = switchValue ? 1 : 0;
      console.log(this.huifangForm.huifang_genjin);
    },
    async huiFangAdd() {
      const { data: res } = await this.$http.post('api', this.huifangForm);
      console.log(JSON.parse(res.data)[0].bianhao_s);
      this.huifangDialogVisible = true;
    },
    async get_tuikuan_add() {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_type: 'get_bianhao', C_table_type: 12 }
      });
      console.log(JSON.parse(res.data)[0].bianhao_l);
      this.addForm.tuikuan_bianhao = JSON.parse(res.data)[0].bianhao_l;
      // this.total = JSON.parse(res.data)[0].total
      this.addDialogVisible = true;
    },

    async gettuikuanList() {
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      });
        console.log(JSON.parse(res.data))
      this.tuikuanList = JSON.parse(res.data)[0].dataList;

      if (!this.tuikuanList) return;
      this.tuikuanList.forEach(function (item) {
        item.yong_flag = item.yong_flag === 1;
      });

      this.total = JSON.parse(res.data)[0].total;

      // console.log(this.total)
    },
    //  分页第一项下拉触发

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.gettuikuanList();
    },
    // 选择页数触发
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.gettuikuanList();
    },

    async addtuikuan() {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return 1;
        this.add_isDisable = true
        setTimeout(() => {
          this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)
        const { data: res } = await this.$http.post('api', this.addForm);
        console.log(JSON.parse(res.data)[0].status);
        if (JSON.parse(res.data)[0].status === 201) {
          this.$message.error('账号错误，请联系管理员')
          return
        } else if ((JSON.parse(res.data)[0].status === 202)) {
          this.$message.error('账户余额不足！')
          return
        } else if ((JSON.parse(res.data)[0].status !== 200)) {
          this.$message.error('退款失败')
          return
        }
        this.$message.success('退款成功');
        this.gettuikuanList();
        this.addDialogVisible = false;
      });
    },
    async addHuifang() {
      this.$refs.huifangFormRef.validate(async valid => {
        if (!valid) return 1;
        this.huifang_isDisable = true
        setTimeout(() => {
          this.huifang_isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)

        const { data: res } = await this.$http.post('api', this.huifangForm);
        console.log(JSON.parse(res.data)[0].status);
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('添加失败');
          return;
        }
        this.$message.success('添加成功');
        this.gettuikuanList();
        this.huifangDialogVisible = false;
      });
    },
    showEditDialog(uid) {
      this.tuikuanInfo(uid);
      this.editDialogVisible = true;
    },
    addDoalogClosed() {
      this.$refs.addFormRef.resetFields();
    },
    huifangDoalogClosed() {
      this.$refs.huifangFormRef.resetFields();
    },
    showHuifangDialog(uid) {
      this.huifangDialogVisible = true;
      this.tuikuanInfo(uid);
    },
    editDoalogClosed() {
      this.$refs.editFormRef.resetFields();
    },
    async tuikuanInfo(uid) {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_table_name: 'tuikuan_info', uid: uid, C_type: 'get_info' }
      });
      // console.log(JSON.parse(res.data))
      console.log(res.data);
      if (JSON.parse(res.data)[0].status !== 200) {
        return this.$message.error('读取失败');
      }

      this.editForm = JSON.parse(res.data)[0].data[0];
      this.huifangForm.huifang_tuikuan_uid = JSON.parse(res.data)[0].data[0].uid;
    },
    async updatetuikuan() {
    },
    // 删除一条记录
    async deleteForm(tuikuanUid) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
      const comfirmResult = await this.$confirm(
        '确定删除该条记录, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err);
      console.log(comfirmResult);
      if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
      const { data: res } = await this.$http.post('api', {
        C_type: 'record_delete',
        C_table_name: 'tuikuan_del',
        C_data1: tuikuanUid
      });
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('删除失败');
        return;
      }
      this.$message.success('删除成功');
      this.gettuikuanList();
    },
      // 删除一条记录
      async tuikuanForm(tuikuanUid) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
      const comfirmResult = await this.$confirm(
        '确认该条退款记录吗?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err);
      console.log(comfirmResult);
      if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
      const { data: res } = await this.$http.post('api', {
        C_type: 'tuikuan_queren',
        tuikuanUid: tuikuanUid
      });
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('确认失败');
        return;
      }
      this.$message.success('确认成功');
      this.gettuikuanList();
    }
  }
};
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important;
  background-color: #f2f6fc;
}

.el_row_two {
  margin-top: 30px;
}
</style>
